import { create } from 'zustand';

/** Estado de UI/sesión (no de servidor — eso va a TanStack Query). */
interface UiState {
  /** Navbar abierto en viewport móvil. */
  navbarOpened: boolean;
  toggleNavbar: () => void;
  setNavbar: (opened: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  navbarOpened: false,
  toggleNavbar: () => set((s) => ({ navbarOpened: !s.navbarOpened })),
  setNavbar: (opened) => set({ navbarOpened: opened }),
}));
